import { FC } from "react";
import { ElectNominationCommitteeForm } from "./electNominationCommitteeDomain";
import { Box, VBox } from "@/components-v2/Box";
import { LinkButton } from "@/components-v2/Button";
import { observer } from "mobx-react";
import { Checkbox } from "@/components-v2/Checkbox";
import { Dialog } from "@/components-v2/Dialog";
import { MTextInput } from "@/components-v2/TextInput";
import { Alert } from "@/components-v2/Alert";

import { useTranslation } from "@/stores/RootStoreContext";

export const ElectNominationCommitteeView: FC<{ form: ElectNominationCommitteeForm | undefined }> =
  observer(({ form }) => {
    const { t } = useTranslation();

    if (!form) {
      return null;
    }

    return (
      <VBox gap={"md"}>
        {form.electionOfMembersWarning && (
          <Alert message={t(form.electionOfMembersWarning)} type={"warning"} />
        )}
        <VBox>
          {form.newNominationCommitteeMembersByName.value.map((committee) => {
            return (
              <Checkbox
                key={committee.id}
                label={committee.name}
                onChange={() => form?.toggleCommittee(committee.id)}
                checked={form.newNominationCommitteeMembersByName.isSelected(committee.id)}
                disabled={form.isProjectLocked}
              />
            );
          })}
        </VBox>
        <Box key="buttonAddNewNominationCommitteeMemberByName">
          <LinkButton
            label={t("decisions.electNominationCommittee.add-member")}
            icon={"plus"}
            onClick={() => form.displayAddNewCommitteeDialog()}
            disabled={form.isProjectLocked}
          />
        </Box>
        {form.isModalDialogVisible && (
          <Dialog
            title={t("decisions.electNominationCommittee.add-member")}
            submitLabel={t("decisions.save")}
            onSubmit={() => form.addNewCommitteeAndClose()}
            onCancel={() => form.hideAddNewCommitteeDialog()}
          >
            <MTextInput label={t("decisions.name")} name={"name"} model={form.committeeName} />
          </Dialog>
        )}
      </VBox>
    );
  });
